interface LegacyRedirect {
  pattern: RegExp
  to: (match: RegExpMatchArray) => string
}

const LEGACY_REDIRECTS: LegacyRedirect[] = [
  // old capital call notice page /:slug/:orgId/transaction/:transactionId → /o-:orgId/portfolio
  {
    pattern: /^\/[^/]+\/(\d+)\/transaction\/\d+$/,
    to: match => `/o-${match[1]}/portfolio`,
  },
]

export default defineNuxtRouteMiddleware((to) => {
  for (const redirect of LEGACY_REDIRECTS) {
    const match = to.path.match(redirect.pattern)
    if (match) {
      return navigateTo(redirect.to(match), { redirectCode: 301 })
    }
  }
})
